export default `float de(vec3 p)
    float r = 1.; 
    float c = 1.; 
    return mix(length(p.xz) - r, length(vec3(p.x, abs(p.y) - c, p.z)) - r, step(c, abs(p.y)));
  }

Alternate method

  float de_line_segment(vec3 p, vec3 a, vec3 b) {
    vec3 ab = b - a;
    float t = clamp(dot(p - a, ab) / dot(ab, ab), 0., 1.);

    return length((ab*t + a) - p);
  }

  float de(vec3 p){
    vec3 a = vec3(0., -1., 0.); 
    vec3 b = vec3(0.,  1., 0.); 
    float r = 1.; 

    return de_line_segment(p, a, b) - r;
  }`